/**
 * TopicHeaderNode - Header node showing topic name and ID
 * Uses React Flow handle for edge connections
 */

import { memo } from 'react'
import { Handle, Position } from '@xyflow/react'
import './TopicHeaderNode.css'

export interface TopicHeaderNodeData extends Record<string, unknown> {
  topicId: string
  topicName: string
}

interface TopicHeaderNodeProps {
  data: TopicHeaderNodeData
}

function TopicHeaderNodeComponent({ data }: TopicHeaderNodeProps) {
  const { topicId, topicName } = data

  return (
    <div className="topic-header-node">
      <div className="topic-header-node__name">{topicName}</div>
      <div className="topic-header-node__id-bubble">
        <span className="topic-header-node__id">{topicId}</span>
      </div>
      {/* Bottom handle for connecting to first card */}
      <Handle
        type="source"
        position={Position.Bottom}
        id="bottom"
        className="topic-header-node__handle"
      />
    </div>
  )
}

export const TopicHeaderNode = memo(TopicHeaderNodeComponent)
